import { render, staticRenderFns } from "./CreateRaceModal.vue?vue&type=template&id=53f319e8"
import script from "./CreateRaceModal.vue?vue&type=script&lang=js"
export * from "./CreateRaceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports